import reminderList from "./reminder-list/ReminderList.vue";
import serviceDocument from "../../services/patient/DocumentService";
import PatientService from "../../services/patient/PatientService";
import ReminderService from "../../services/reminder/ReminderService";
import { StorageService } from "../../services/StorageService";
import i18n from "../../i18n/index";

export default {
  components: {
    reminderList
  },
  data: () => ({
    showGrid: true,
    dialog: false,
    menu: false,
    observation: "",
    reminderDate: new Date().toISOString().substr(0, 10),
    patient: {
      id: "",
      documentType: "",
      document: "",
      fullname: "",
      address: "",
      cellPhoneNumber: "",
      phoneNumber: "",
      isPac: false,
      isPolicy: false
    },
    documentTypeItems: [],
    disableDocumentType: false,
    disableDocument: false,
    orderId: null,
    reminderId: null,
    seen: false,
    loading: false
  }),
  created() {
    this.getDocumentTypes();
  },
  methods: {
    getDocumentTypes() {
      serviceDocument.getDocuments().then(response => {
        this.documentTypeItems = response.data;
      });
    },
    closeReminder() {
      this.dialog = false;
      this.restoreFields();
    },
    searchPatient() {
      if (!this.patient.documentType) {
        this.showError(i18n.t('no-options-selected-for-document-type'));
        return;
      }

      if (!this.patient.document) {
        this.showError(i18n.t('no-patient-id'));
        return;
      }

      PatientService.getByDocument(
        this.patient.documentType,
        this.patient.document
      ).then(response => {
        if (response && response.data && response.data.id) {
          const data = response.data;

          this.patient.id = data.id;
          this.patient.fullname = data.name;
          this.patient.address = data.address;
          this.patient.cellPhoneNumber = data.mobilePhone;
          this.patient.phoneNumber = data.phone;
          this.patient.isPac = data.PAC;
          this.patient.isPolicy = data.policy;
        } else {
          this.showError(i18n.t('patient-not-exist'));
        }
      });
    },

    saveReminder() {
      if (!this.patient.id) {
        this.showError(i18n.t('no-options-selected-for-patient'));
        return;
      }

      if (!this.observation) {
        this.showError(i18n.t('you-must-enter-an-observation'));
        return;
      }

      let userData = StorageService.getUserData();

      this.loading = true;

      ReminderService.saveReminder(
        this.reminderId,
        this.patient.id,
        userData.id,
        this.reminderDate,
        this.observation,
        this.seen
      ).then(response => {
        this.$notify({
          group: "app",
          type: "success",
          text: i18n.t('reminder.saved-successfully')
        });

        this.showGrid = true;
        this.patient = {
          id: "",
          documentType: "",
          document: "",
          fullname: "",
          address: "",
          cellPhoneNumber: "",
          phoneNumber: "",
          isPac: false,
          isPolicy: false
        };
        this.reminderDate = new Date().toISOString().substr(0, 10);
        this.observation = "";

        this.loading = false;
        this.$refs.reminderList.getReminders();
      }).catch(error => {
        this.loading = false;
        this.showError(i18n.t('reminder.error-occurred'));
      });
    },

    showError(text) {
      this.$notify({
        group: "app",
        type: "error",
        text
      });
    },

    onRowClick(reminder) {
      this.showGrid = false;
      const patient = reminder.patient;

      this.reminderId = reminder.id;
      this.orderId = reminder.orderId;
      this.patient.id = patient.id;
      this.patient.documentType = patient.idIdentificationType.id;
      this.patient.document = patient.identification;
      this.reminderDate = reminder.reminderDate;
      this.observation = reminder.observation;
      this.seen = reminder.seen;

      this.disableDocument = true;
      this.disableDocumentType = true;
      this.searchPatient();
    },

    restoreFields() {
      this.reminderId = null;
      this.orderId = null;
      this.patient = {
        id: "",
        documentType: "",
        document: "",
        fullname: "",
        address: "",
        cellPhoneNumber: "",
        phoneNumber: "",
        isPac: false,
        isPolicy: false
      }
      this.reminderDate = new Date().toISOString().substr(0, 10);
      this.observation = "";
      this.disableDocument = false;
      this.disableDocumentType = false;
      this.showGrid = !this.showGrid;
    }
  }
};
